import { Grid } from '@mui/material'
import RemoveIcon from '@mui/icons-material/Close'
import { UseFieldArrayRemove } from 'react-hook-form'

import { TextFieldRegistered, TextMaskFieldRegistered } from '../../Components'

export const ProfessionalReferenceBlock = ({ index, remove }: { index: number; remove: UseFieldArrayRemove }) => {
  return (
    <Grid item rowSpacing={2} style={{ backgroundColor: '#1976d214', padding: 10, borderRadius: 10, marginTop: 10 }}>
      <Grid container item>
        <Grid container item xs={12} sm={10} md={10} order={{ xs: 2, sm: 1 }}>
          <Grid item xs={12} sm={4} md={4}>
            <TextFieldRegistered required name={`professional.${index}.company`} label="Empresa" />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <TextFieldRegistered required name={`professional.${index}.name`} label="Nombre" />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <TextMaskFieldRegistered
              label="Número del telefono"
              name={`professional.${index}.phone`}
              mask={(value) => (value?.toString()?.length === 9 ? '(\\0 000) 000000' : '(\\0 00) 000000[0]')}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={2} md={2} flex={1} textAlign={'right'} order={{ xs: 1, sm: 2 }}>
          <RemoveIcon onClick={() => remove(index)} style={{ cursor: 'pointer' }} />
        </Grid>
      </Grid>
    </Grid>
  )
}
